export class TransactionStatusDate {
    date: Date;
    executionId?: string;

    constructor(date: Date, executionId?: string) {
        this.date = date;
        if (executionId) {
            this.executionId = executionId;
        }
    }
}
